<template>
  <div class="password">
    <van-form @submit="onSubmit" class="line-form">
      <van-field v-model="oldVerifyCode"
        label="旧手机号验证码" placeholder="请输入旧手机号验证码" clearable center
        :rules="[{ required: true, message: '请填写旧手机号验证码' }]"
      >
        <template #button>
          <van-button plain type="info" native-type="button" size="small" class="code-btn" @click.stop="getSMSCode">
            {{ numCount == 60 ? '获取验证码' : `${numCount}s` }}
          </van-button>
        </template>
      </van-field>
      <van-field v-model="newMobileNum"
        type="number"
        label="新手机号" placeholder="请输入新手机号"
        :rules="[{ required: true, message: '请填写新手机号' }]"
      />
      <van-field v-model="newVerifyCode"
        label="新手机验证码" placeholder="请输入新手机验证码" clearable center
        :rules="[{ required: true, message: '请填写新手机验证码' }]"
      >
        <template #button>
          <van-button plain type="info" native-type="button" size="small" class="code-btn" @click.stop="getSMSCodeNew">
            {{ newNumCount == 60 ? '获取验证码' : `${newNumCount}s` }}
          </van-button>
        </template>
      </van-field>
      <div class="btn-group">
        <van-button class="btn-save" block type="info" native-type="submit">保存</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import api from '@/utils/api/personCenter'
// import MD5 from 'md5.js'
// import commonApi from '@/utils/api/common.js'
import moduleMixins from '@/mixins/moduleMixins'

export default {
  components: {},
  mixins: [moduleMixins],
  props: {},
  data() {
    return {
      oldVerifyCode: '',// 旧手机号的验证码
      newMobileNum: '',// 新手机	
      newVerifyCode: '',// 新手机的验证码
      numCount:60,// 倒计时60s
      newNumCount:60,// 新手机号倒计时60s
      userFullInfo:{},// 用户信息
    };
  },
  watch: {},
  computed: {
    navTitle() {
      return '手机绑定'
    }
  },
  methods: {
    // 获取新手机号短信验证码
    getSMSCodeNew(){
      if(this.newNumCount != 60 ) {
        this.$toast('不允许频繁请求')
        return
      }
      if(!this.newMobileNum) {
        this.$toast('请输入新手机号')
        return
      }
      api.sendVerification({
        mobileNo: this.newMobileNum
      }).then(() => {
        this.$toast('短信发送成功')
        let timer = setInterval(()=> {
          this.newNumCount--
          if(this.newNumCount <= 0) {
            clearInterval(timer)
            this.newNumCount = 60
          }
        }, 1000)
      })
    },
    // 获取短信验证码
    getSMSCode() {
      if(this.numCount != 60 ) {
        this.$toast('不允许频繁请求')
        return
      }
      if(!this.userFullInfo.mobilePhone) {
        this.$toast('请输入手机号')
        return
      }
      api.sendVerification({
        mobileNo: this.userFullInfo.mobilePhone
      }).then(() => {
        this.$toast('短信发送成功')
        let timer = setInterval(()=> {
          this.numCount--
          if(this.numCount <= 0) {
            clearInterval(timer)
            this.numCount = 60
          }
        }, 1000)
      })
    },
    // 表单验证后提交保存
    onSubmit() {
      let params = {}
      params.oldValidate = this.oldVerifyCode
      params.newMobilePhone = this.newMobileNum
      params.validate = this.newVerifyCode
      api
        .updateMobilePhone(params)
        .then(res => {
          console.log(res)
          if(res.code == 0){
            this.$toast('修改手机号成功');
            this.$bus.$emit('refreshUserInfo')
            setTimeout(()=>{
              this.$router.go(-1)
            },2000)
          }else{
            this.$toast(res.message)
          }
 
        })
        .catch(err => {
          this.$toast(err.response.data.message)
          console.log(err)
        })
    },
    loadData(){// 获取主数据
      let params = {}
      // 
      
    },
  },
  created() {},
  mounted() {
    this.userFullInfo = this.$store.state.userFullInfo ? this.$store.state.userFullInfo : '';
  }
};
</script>
<style lang="scss" scoped>
.password {
  height: 100vh;
  background-color: #fff;
  .line-form {
    padding: 15px;
    background-color: #fff;
    ::v-deep .van-cell {
      display: block;
      .van-field__label {
        width: 100%;
        padding-bottom: 5px;
      }
      .van-field__value .van-field__body {
        padding: 5px 10px;
        border: 1px solid #ddd;
      }
      &::after {
        border-bottom: 0;
      }
    }
    .btn-group {
      margin: 50px 20px;
      .btn-save{
        background: #1D84FF;
        border-radius: 5px;
      }
    }
  }
}
</style>